import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  container: css`
    display: flex;
    flex-direction: column;
    inline-size: 100%;
  `,
}
